'use client'

import PropTypes from 'prop-types'
import { AsyncPaginate } from 'react-select-async-paginate'
import styles from './PaginatedSearchInput.module.scss'
import { CaretDownIcon } from '@repo/ui/CaretDownIcon'
import MUIInputLabel from '@mui/material/InputLabel'
import { useEffect, useState } from 'react'

export const PaginatedSearchInput = ({
  label = 'Source',
  onChange,
  value,
  loadOptions,
  disabled,
  cacheUniqs,
  searchable = true
}) => {
  const [showLabelInSelectedState, setShowLabelInSelectedState] = useState(false)
  const [menuIsOpen, setMenuIsOpen] = useState(false)

  useEffect(() => {
    setShowLabelInSelectedState(Boolean(value) || menuIsOpen)
  }, [value, menuIsOpen])

  return (
    <div style={{ flex: 1, position: 'relative' }}>
      <MUIInputLabel
        focused={showLabelInSelectedState}
        shrink={showLabelInSelectedState}
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          zIndex: 1,
          top: showLabelInSelectedState ? 0 : '15px',
          left: showLabelInSelectedState ? 0 : '11px',
          transition: 'all 200ms',
          transform: showLabelInSelectedState ? 'translate(10px, -7px) scale(0.75)' : 'translate(0, 0)',
          backgroundColor: showLabelInSelectedState ? 'white' : 'transparent',
          padding: '0 4px',
          color: 'text.secondary'
        }}
      >
        {label}
      </MUIInputLabel>
      <AsyncPaginate
        data-testid="PaginatedSearchInput"
        debounceTimeout={0}
        defaultProps
        loadOptionsOnMenuOpen
        cacheUniqs={cacheUniqs || []}
        value={value}
        aria-label={label}
        loadOptions={loadOptions}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        onChange={onChange}
        isSearchable={searchable}
        isDisabled={disabled}
        className={styles.autocompletePaginated}
        placeholder={''}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator: () => <CaretDownIcon sx={{ opacity: 0.56 }} />
        }}
        styles={{
          menu: (base) => ({
            ...base,
            cursor: 'pointer',
            zIndex: 9999,
            padding: '4px 8px',
            boxShadow:
              '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)'
          }),
          option: (base) => ({
            ...base,
            cursor: 'pointer',
            marginBottom: '1px',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            color: 'rgba(5, 28, 51, 0.87) !important',
            minHeight: '48px',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
          }),
          control: (base, state) => {
            const borderColor = state.menuIsOpen || state.isFocused ? '#3D517B' : 'rgba(0, 0, 0, 0.23)'
            return {
              ...base,
              cursor: 'pointer',
              height: 53,
              borderWidth: state.menuIsOpen || state.isFocused ? '2px' : '1px',
              borderColor,
              '&:hover': { borderColor: '#3D517B' }
            }
          }
        }}
        additional={{
          page: 1
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: 'rgba(61, 81, 123, 0.08)',
            primary25: 'rgba(61, 81, 123, 0.08)'
          }
        })}
      />
    </div>
  )
}

PaginatedSearchInput.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  loadOptions: PropTypes.func,
  disabled: PropTypes.bool,
  cacheUniqs: PropTypes.array,
  searchable: PropTypes.bool
}
